import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed} from 'vue';
import CoreUiAvatar from "~/core-ui/vue/chat/CoreUiAvatar.vue";


const __default__ = {
    name: "CoreUiOperatorAvatar"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    operator: {},
    statusId: {},
    size: {},
    statusColor: {},
    showDialogCount: { type: Boolean },
    siteId: {},
    showStatus: { type: Boolean, default: true }
  },
  setup(__props: any) {

let props = __props;

let computedStatusId = computed(() => {
    return typeof props.statusId == "number" ? props.statusId : props.operator.statusId;
});

let dialogCount = computed(() => {
    let result: number;
    if (props.showDialogCount && props.operator) {
        let dialogCount = props.operator.dialogCount;
        if (dialogCount) {
            let siteId = props.siteId;
            if (siteId) {
                result = dialogCount[siteId];
            } else {
                result = 0;
                for (let siteId in dialogCount) {
                    if (dialogCount.hasOwnProperty(siteId)) {
                        result += dialogCount[siteId];
                    }
                }
                if (!result) {
                    result = null;
                }
            }
        }
    }
    return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreUiAvatar, {
    "status-color-class": `status-${_unref(computedStatusId)}`,
    "status-color": __props.statusColor,
    src: __props.operator.avatar,
    size: __props.size,
    "show-status": __props.showStatus,
    "badge-tooltip": "Количество активных диалогов (диалог не завершён и открыт в приложении)"
  }, _createSlots({ _: 2 }, [
    (_unref(dialogCount))
      ? {
          name: "badge",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(dialogCount)), 1)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["status-color-class", "status-color", "src", "size", "show-status"]))
}
}

})